// Estado "enviando": barra de progresso REAL do POST /api/upload (via XHR
// upload.onprogress). Sem mockup aprovado — desenhada na linguagem escura. Quando o
// tamanho não é computável, cai para uma faixa indeterminada com texto.

import { corC, fonteC } from '../../styles/tokensCelular';

interface Props {
  ratio: number; // 0..1
  indeterminado: boolean;
}

export function Enviando({ ratio, indeterminado }: Props): JSX.Element {
  const pct = Math.round(ratio * 100);
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px 28px',
        gap: 18,
      }}
    >
      <div
        style={{
          fontFamily: fonteC.condensada,
          fontWeight: 600,
          fontSize: 17,
          letterSpacing: '.18em',
          color: corC.texto,
        }}
      >
        ENVIANDO
      </div>
      <div style={{ width: '100%', maxWidth: 300 }}>
        <div style={{ height: 6, background: corC.divisorFraco, overflow: 'hidden' }}>
          <div
            style={{
              height: '100%',
              width: indeterminado ? '40%' : `${pct}%`,
              background: corC.azul,
              transition: indeterminado ? 'none' : 'width .15s linear',
            }}
          />
        </div>
        <div
          style={{
            marginTop: 10,
            textAlign: 'center',
            fontFamily: fonteC.mono,
            fontSize: 12,
            color: corC.muted,
            letterSpacing: '.06em',
          }}
        >
          {indeterminado ? 'enviando o áudio…' : `${pct}%`}
        </div>
      </div>
      <div style={{ fontSize: 12.5, color: corC.muted, textAlign: 'center', maxWidth: 260, lineHeight: 1.5 }}>
        Não feche esta tela até o código aparecer.
      </div>
    </div>
  );
}
